import { useCallback } from "react";

import { HotelClinicListItem } from "@/pages/HotelPlanning/clinic-arrival/types";
import { useClinicUnassignedPassengersTableActions } from "@/stores/use-clinic-arrival-unassigned-passengers-table";

/** Same `processRowUpdate` as the DataGrid (paste, keyboard) + copy `userId` to clipboard on non-empty driver assignment. */
export function useClinicUnassignedDriverAssignProcessRowUpdate() {
    const { processRowUpdate } = useClinicUnassignedPassengersTableActions();

    return useCallback(
        (newRow: HotelClinicListItem, oldRow: HotelClinicListItem) => {
            const out = processRowUpdate(newRow, oldRow);
            const uid =
                newRow.userId != null && String(newRow.userId).trim() !== "" ? String(newRow.userId).trim() : null;
            if (uid) {
                void navigator.clipboard.writeText(uid).catch(() => {});
            }
            return out;
        },
        [processRowUpdate]
    );
}
